module.exports = __webpack_public_path__ + "img/border_rectangle4.4be2353c.svg";